import axios from 'axios';

export default class ItemsRESTRepository {
  constructor(publicUrl, customConfig) {
    this.publicUrl = publicUrl;
    this.customConfig = customConfig;
  }

  getItem(itemid) {
    return axios.get(`${this.publicUrl}/items/${itemid}`, this.customConfig);
  }

  patchItem(itemid, payload) {
    return axios.patch(
      `${this.publicUrl}/items/${itemid}`,
      payload,
      this.customConfig
    );
  }

  getItemsByCategoryType(categorytypeid) {
    return axios.get(
      `${this.publicUrl}/categorytypes/${categorytypeid}/items`,
      this.customConfig
    );
  }

  getItemsByCategory(categoryid) {
    return axios.get(
      `${this.publicUrl}/categories/${categoryid}/items`,
      this.customConfig
    );
  }

  getWorkOrders() {
    return axios.get(`${this.publicUrl}/workorders`, this.customConfig);
  }

  getAllocationGroupsWithAllocations() {
    return axios.get(
      `${this.publicUrl}/allocationgroups?include=allocations`,
      this.customConfig
    );
  }

  getWorkOrderItems(workOrderId, itemId) {
    return axios.get(
      `${this.publicUrl}/workorderitems?workorderid=${workOrderId}&itemid=${itemId}`,
      this.customConfig
    );
  }
}
